import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import TheVioletKings from "../img/the-violet-kings.webp";
import Goldhope from "../img/goldhope.webp";
import Sxmson from "../img/sxmson.webp";
import NikitaBassi from "../img/nikita-bassi.webp";

export const PortfolioSection = () => {
  return (
    <Container fluid as="section" className="portfolio-section">
      <Container>
        <h2  data-aos="fade-right">Current Projects</h2>
        <p  data-aos="fade-left" className="d-block text-center margin-left-right-auto mb-5 portfolio-description-text">
          I'm always involved in a wide variety of projects for differing
          artists, below are some of the artists I have worked with in the
          studio and live in recent times.
        </p>

        <Row className="portfolio-row">
          <Col data-aos="fade-right">
            <a
              href="https://www.facebook.com/TheVioletKings/"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                fluid
                src={TheVioletKings}
                width="500"
                height="350"
                alt="The Violet Kings band image"
                className="image"
              />
              <div className="overlayOne">
                <div className="text">
                  <br />
                  <br />
                  The Violet Kings
                  <p>Blues Rock Band</p>
                </div>
              </div>
              <div className="overlayTwo">
                <div className="text">Find out More</div>
              </div>
            </a>
          </Col>
          <Col data-aos="fade-left">
            <a
              href="https://linktr.ee/goldhopemusic"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                fluid
                src={Goldhope}
                width="500"
                height="350"
                alt="Goldhope band image"
                className="image"
              />
              <div className="overlayOne">
                <div className="text">
                  <br />
                  <br />
                  Goldhope
                  <p>Alt Pop Band</p>
                </div>
              </div>
              <div className="overlayTwo">
                <div className="text">Find out More</div>
              </div>
            </a>
          </Col>
        </Row>
        <Row className="portfolio-row">
          <Col data-aos="fade-right">
            <a href="https://sxmson.co.uk/" target="_blank" rel="noreferrer">
              <Image
                fluid
                src={Sxmson}
                width="500"
                height="350"
                alt="Image of the artist Sxmson (pronounced Samson)"
                className="image"
              />
              <div className="overlayOne">
                <div className="text">
                  <br />
                  <br />
                  Sxmson
                  <p>Pop Singer-Songwriter</p>
                </div>
              </div>
              <div className="overlayTwo">
                <div className="text">Find out More</div>
              </div>
            </a>
          </Col>
          <Col data-aos="fade-left">
            <a
              href="https://www.nikitabassi.com/"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                fluid
                src={NikitaBassi}
                width="500"
                height="350"
                alt="Image of the artist Nikita Bassi"
                className="image"
              />
              <div className="overlayOne">
                <div className="text">
                  <br />
                  <br />
                  Nikita Bassi
                  <p>RnB Singer-Songwriter</p>
                </div>
              </div>
              <div className="overlayTwo">
                <div className="text">Find out More</div>
              </div>
            </a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
